import { BMIField } from 'bz-core-controls';
import DatePicker from 'bz-core-controls/controls/clinical/clinical-date-picker';
import DateTimePicker from 'bz-core-controls/controls/clinical/clinical-datetime-picker';
import Lookup from 'bz-core-controls/controls/clinical/clinical-lookup';
import ClinicalLookup from 'bz-core-controls/controls/clinical/clinical-lookup';
import Numeric from 'bz-core-controls/controls/clinical/clinical-numeric';
import ClinicalNumeric from 'bz-core-controls/controls/clinical/clinical-numeric';
import Text from 'bz-core-controls/controls/clinical/clinical-text';
import ClinicalText from 'bz-core-controls/controls/clinical/clinical-text';
import { ClinicalTimePicker } from 'bz-core-controls/controls/clinical/clinical-time-picker';
import Psfs from 'bz-core-controls/controls/clinical/psfs';
import ClinicalReadOnly from 'bz-core-controls/controls/clinical/read-only';
import Slider from 'bz-core-controls/controls/clinical/slider';
import TableJson from 'bz-core-controls/controls/clinical/table/table';
import YesNo from 'bz-core-controls/controls/form/yes-no';
import TimeDuration from 'bz-core-controls/controls/general/date/time-duration';
import Signature from 'bz-core-controls/controls/general/signature-control';
import RadioButtonGroup from 'bz-core-controls/controls/touch/radio-button-group';
import DraftFileUpload from '../../controls/file-upload';

class Utils {
  getDefaultToolbar() {
    let sizes = [];

    for (let i = 8; i <= 32; i += 2) {
      sizes.push({ label: `${i} px`, key: `${i}px`, style: { fontSize: i } });
    }

    return [
      {
        type: 'composite',
        value: [
          { icon: 'fa-bold', style: 'BOLD' },
          { icon: 'fa-italic', style: 'ITALIC' },
          { icon: 'fa-underline', style: 'UNDERLINE' },
          { icon: 'fa-strikethrough', style: 'STRIKETHROUGH' }
        ]
      },
      {
        type: 'dropdown',
        icon: 'fa-square',
        prefix: 'colour',
        mimic: true,
        value: [
          {
            icon: 'fa-square',
            key: 'red',
            style: { color: 'rgba(255, 0, 0, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'orange',
            style: { color: 'rgba(255, 127, 0, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'yellow',
            style: { color: 'rgba(180, 180, 0, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'green',
            style: { color: 'rgba(0, 180, 0, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'blue',
            style: { color: 'rgba(0, 0, 255, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'indigo',
            style: { color: 'rgba(75, 0, 130, 1.0)' }
          },
          {
            icon: 'fa-square',
            key: 'violet',
            style: { color: 'rgba(127, 0, 255, 1.0)' }
          }
        ]
      },
      {
        type: 'dropdown',
        prefix: 'size',
        mimic: true,
        icon: 'fa-text-height',
        value: sizes
      }
    ];
  }

  getClinicalControls() {
    return {
      Text: {
        tag: 'Text',
        type: 'string',
        icon: 'fa-file-text-o',
        attributes: [
          'placeholder',
          'min',
          'max',
          'rows',
          'maitland',
          'src',
          'full-lookup-path',
          'appendMode',
          'keyquestion'
        ],
        advanced: ['formulakey', 'hideFromForms', 'excludeFromAiAutofill'],
        control: Text
      },
      Lookup: {
        tag: 'Lookup',
        type: 'any',
        icon: 'fa-check-square-o',
        attributes: [
          'placeholder',
          'src',
          'full-lookup-path',
          'other',
          'keyquestion',
          'autoflag',
          'multi'
        ],
        advanced: [
          'keyquestion',
          'autoflag',
          'formulakey',
          'hideFromForms',
          'excludeFromAiAutofill'
        ],
        control: Lookup
      },
      YesNo: {
        tag: 'Yes No',
        type: 'bool',
        icon: 'fa-thumbs-o-up',
        attributes: ['text-if-yes', 'text-if-no', 'keyquestion', 'autoflag'],
        advanced: ['formulakey', 'hideFromForms', 'excludeFromAiAutofill'],
        control: YesNo
      },
      Numeric: {
        tag: 'Number',
        type: 'number',
        icon: 'fa-hashtag',
        attributes: ['placeholder', 'min', 'max', 'decimals', 'keyquestion', 'autoflag'],
        advanced: ['formulakey', 'scoreGoalLink', 'hideFromForms', 'excludeFromAiAutofill'],
        control: Numeric
      },
      Options: {
        tag: 'Options',
        type: 'any',
        icon: 'fa-dot-circle-o',
        attributes: ['multi', 'list', 'other', 'lookuplist', 'keyquestion', 'autoflag'],
        advanced: ['formulakey', 'hideFromForms'],
        control: RadioButtonGroup
      },

      DatePicker: {
        tag: 'Date',
        type: 'date',
        icon: 'fa-calendar-o',
        attributes: ['placeholder'],
        advanced: ['keyquestion', 'hideFromForms', 'excludeFromAiAutofill'],
        control: DatePicker
      },
      TimePicker: {
        tag: 'Time',
        type: 'date',
        icon: 'fa-clock-o',
        attributes: ['placeholder', 'keyquestion'],
        control: ClinicalTimePicker
      },
      Table: {
        tag: 'Table',
        type: 'any',
        icon: 'fa-table',
        attributes: ['tableConfig'],
        control: TableJson
      },
      TimeDuration: {
        tag: 'TimeDuration',
        type: 'string',
        icon: 'fa-arrows-h',
        attributes: ['placeholder', 'keyquestion', 'autoflag'],
        control: TimeDuration
      },

      BMIField: {
        tag: 'BMI',
        type: 'string',
        attributes: [],
        icon: 'fa-heart-o',
        control: BMIField
      },
      Label: {
        tag: 'Label',
        type: 'any',
        icon: 'fa-info-circle',
        attributes: ['text', 'size', 'hint'],
        advanced: ['hideFromForms'],
        control: ClinicalReadOnly
      },
      DateTimePicker: {
        tag: 'Datetime Picker',
        type: 'date',
        icon: 'fa-calendar-o',
        attributes: ['placeholder'],
        control: DateTimePicker
      },
      Formula: {
        tag: 'Formula',
        type: 'any',
        icon: 'fa-calculator',
        attributes: ['text', 'size', 'formula'],
        advanced: ['hint', 'formulakey', 'scoreGoalLink', 'hideFromForms'],
        control: ClinicalReadOnly
      },

      Slider: {
        tag: 'Slider',
        type: 'number',
        icon: 'fa-sliders',
        attributes: ['min', 'max', 'increment'],
        advanced: ['formulakey', 'scoreGoalLink', 'hideFromForms'],
        control: Slider
      },
      Signature: {
        tag: 'Signature',
        type: 'string',
        attributes: [],
        icon: 'fa-pencil',
        control: Signature
      },
      PSFS: {
        tag: 'PSFS',
        type: 'any',
        attributes: ['ispsfs'],
        icon: 'fa-line-chart',
        control: Psfs
      },
      FileUpload: {
        tag: 'File Upload',
        type: 'any',
        icon: 'fa-cloud-upload',
        attributes: [],
        control: DraftFileUpload
      }
    };
  }
}

export default new Utils();
